module.exports = __webpack_public_path__ + "media/thumbnails/glove-style-2-ef92aaff.svg";